import moment from 'moment';
import config from '../config';

const toTwoDigits = (value) => {
  return String(value).padStart(2, '0');
};

const formaters = {
  formatTimeWholeSeconds: (value) => {
    const hours = Math.floor(value / 3600);
    const minutes = Math.floor((value % 3600) / 60);
    const seconds = Math.floor(value % 60);
    return `${toTwoDigits(hours)}:${toTwoDigits(minutes)}:${toTwoDigits(seconds)}`;
  },

  formatTimeHundredthSeconds: (value) => {
    const hundredths = Math.floor((value % 1) * 100);
    return `${formaters.formatTimeWholeSeconds(value)}.${toTwoDigits(hundredths)}`;
  },

  addLeadingZeros(n, max) {
    if (`${n}`.length === `${max}`.length) {
      return `${n}`;
    }
    return this.addLeadingZeros(`0${n}`, max); // woot recursion!
  },
  msTohmsms(ms, params = { exact: true, ms: true }) {
    let milliseconds = parseInt((ms % 1000) / 100),
      seconds = parseInt((ms / 1000) % 60),
      minutes = parseInt((ms / (1000 * 60)) % 60),
      hours = ms < 1000 * 60 * 60 ? 0 : parseInt((ms / (1000 * 60 * 60)) % 24);
    if (hours > 0) {
      hours = hours < 10 ? '0' + hours : hours;
      hours += ':';
    } else {
      hours = '';
    }
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;
    if (!params.ms) {
      return hours + minutes + ':' + seconds;
    }
    if (params.exact) {
      milliseconds = parseInt(ms % 1000);
      milliseconds = ('00' + milliseconds).slice(-3);
      return hours + minutes + ':' + seconds + '.' + milliseconds;
    }
    return hours + minutes + ':' + seconds + '.' + milliseconds;
  },
  hhmmssToSs(time) {
    return time.split(':').reduce((acc, timeToCode) => 60 * acc + +timeToCode);
  },
  toTitle(str) {
    if (str !== str.toLowerCase()) {
      return str; // if the string already has capitalization use it
    }
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },

  formatNumber(num) {
    if (!num) {
      return null;
    }
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  },

  formatDate(date) {
    return moment(date).format('MMM Do YYYY');
  },

  dateSlashes(date) {
    return moment(date).format('DD/MM/YYYY');
  },

  formatDateTime(date) {
    return moment(date).format('MMM Do YYYY, hh:mmA');
  },

  formatRemainingDays(date) {
    if (!date || typeof date !== 'number' || date < 1) {
      return null;
    }

    const days = Math.floor(date / (1000 * 60 * 60 * 24));
    const hours = Math.floor((date % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((date % (1000 * 60 * 60)) / (1000 * 60));
    return {
      days,
      hours,
      minutes,
    };
  },

  capitalizeFirstLetter(string) {
    let i = 0;
    while (i < string.length && string.charAt(i) === ' ') {
      i++;
    }
    return string
      .slice(0, i)
      .concat(string.slice(i, i + 1).toUpperCase())
      .concat(string.slice(i + 1));
  },

  // we need to reuse the image configuration to creating too many permutations for each assets
  IMAGE_LARGE: 'height=500',
  IMAGE_LARGE_W: 'height=500',
  IMAGE_SMALL: 'height=250',
  IMAGE_XSMALL: 'height=150',
  IMAGE_XXSMALL: 'height=40',

  getTransformedImagePath(cover, params) {
    if (!cover) {
      return null;
    }

    let image;

    if (typeof cover === 'string') {
      image = cover;
    } else if (cover.url) {
      image = cover.url;
    }

    if (image.indexOf('s3.amazonaws.com') === -1) {
      return image;
    }

    image = image.replace(/\/\/s3.amazonaws.com\/(.*)\.pippa\.io\//, '');

    const url = [config.cmsImageTransformDomain];

    url.push(image);

    return url.join('/') + `${params && '?' + params}`;
  },

  getAudioCdnUrl(audio = {}) {
    if (!audio || !audio.url) {
      return null;
    }
    return audio.url.replace('s3.amazonaws.com/', '');
  },

  parseErrorMessage(err) {
    const errors = err.responseJSON.detail;
    if (errors.message) {
      return errors.message;
    }
    return Object.keys(errors).map((key) => {
      if (errors[key].message) {
        return errors[key].message;
      }
    });
  },

  stripHTML: (string = '') => string.replace(/&amp;/g, '&').replace(/<(?:.|\n)*?>|&nbsp;?/gm, ''),

  formatNarrowNumbers: (num) => {
    if (num >= 1000 && num < 1000000) {
      return Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + 'k';
    } else if (num >= 1000000) {
      return Math.sign(num) * (Math.abs(num) / 1000000).toFixed(2) + 'M';
    } else {
      return num;
    }
  },
};

export default formaters;
